import * as e from "react";
import a from "../lib/IconBase.es.js";
import c from "../defs/DotsThreeVertical.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: c }));
o.displayName = "DotsThreeVerticalIcon";
const m = o;
export {
  m as DotsThreeVertical,
  o as DotsThreeVerticalIcon
};
